<script setup>
  import { useTemplateRef } from 'vue';

  const emit = defineEmits(['copied']);

  const copied = defineModel();

  const copyTextArea = useTemplateRef('copy-text-area');

  function copy(text) {
    if (!copyTextArea) {
      console.warn('Copy text area element not found');
    }

    copyTextArea.value.value = text;
    copyTextArea.value.focus();
    copyTextArea.value.select();

    try {
      document.execCommand('copy');
      emit('copied');
      setCopied();
    } catch (err) {
      console.error('Fallback: Failed to copy text: ', err);
    }
  }

  function setCopied() {
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 3000);
  }
</script>

<template>
  <textarea ref="copy-text-area" style="position: fixed; top: -999999px; left: -999999px;"></textarea>
  <slot :copy="copy" />
</template>
